import { Fragment } from "react";

import TrainingHistoryTable from "@/components/ai-training/training-history-table/training-history-table";

const TrainingHistory = () => {
    return (
        <Fragment>
            <>
                <TrainingHistoryTable />
            </>
        </Fragment>
    );
};

export default TrainingHistory;
